var map = {
	"./1.png": 84626,
	"./agoda.png": 79757,
	"./booking.png": 50730,
	"./default.png": 17588,
	"./expedia.png": 26383,
	"./google.png": 15478,
	"./holidaycheck.png": 90159,
	"./hostelworld.png": 1240,
	"./hotelde.png": 8180,
	"./hotelescom.png": 90962,
	"./hotelscom.png": 83907,
	"./hrs.png": 77686,
	"./internal.png": 51784,
	"./lastminute.png": 2915,
	"./luxuryescapes.png": 43730,
	"./makemytrip.png": 89694,
	"./marriott.png": 87569,
	"./opentable.png": 71287,
	"./orbitz.png": 66033,
	"./priceline.png": 73134,
	"./rakuten.png": 96231,
	"./travelocity.png": 7417,
	"./traveloka.png": 13452,
	"./trip.png": 16266,
	"./tripadvisor.png": 3252,
	"./trivago.png": 62933,
	"./wongnai.png": 6850,
	"./yelp.png": 17409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14384;